module.exports = __webpack_public_path__ + "public/images/nyt@2x.a4a067f2d74e0386bc745a28652bb5af.png";